export default __webpack_public_path__ + "static/media/headset5.6e698219.jfif";